/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TenantPublicGradingSettingsTaskGradeProjectorsAnyOf } from './tenantPublicGradingSettingsTaskGradeProjectorsAnyOf';

export type TenantPublicGradingSettingsTaskGradeProjectors = TenantPublicGradingSettingsTaskGradeProjectorsAnyOf | null;
